import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { Theme, createStyles } from '@material-ui/core';
import General from './General';
import UseCases from './UseCases';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      backgroundColor: "#ffffff",
      flexGrow: 1,
      justifyContent: "center",
      marginTop: theme.spacing(9),
      [theme.breakpoints.down('sm')]: {
        marginTop: theme.spacing(12),
      }
    },
   
  }),
);

const Home: React.FC = () => {
    const classes = useStyles();

    return (
        <main className={classes.root}>
            <General />
            <UseCases />
            
        </main>
    );
  }
  
  export default Home;